import React from 'react';
import { Link } from 'react-router-dom';
import { Anchor, Users, Shield, TrendingUp, Package, FileCheck, Euro, BarChart3 } from 'lucide-react';

export default function B2bLandingPage() {
  return (
    <div className="min-h-screen" style={{ background: 'linear-gradient(180deg, #0c1929 0%, #0f2942 50%, #0c1929 100%)' }}>
      {/* Hero */}
      <section className="relative py-20 px-4 text-center">
        <div className="max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full mb-6 text-sm font-medium" 
               style={{ background: 'rgba(6,182,212,0.15)', color: '#22d3ee', border: '1px solid rgba(6,182,212,0.3)' }}>
            <Shield size={16} />
            Marketplace Esclusivo B2B
          </div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" style={{ lineHeight: '1.15' }}>
            Barche Usate B2B tra
            <span className="block" style={{ color: '#22d3ee' }}>Concessionari Certificati</span>
          </h1>
          <p className="text-lg md:text-xl mb-8" style={{ color: 'rgba(255,255,255,0.7)' }}>
            Il mercato B2B nautico italiano muove oltre <strong style={{ color: '#fbbf24' }}>€800 milioni l'anno</strong> con circa 12.000 unità scambiate tra professionisti del settore.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/boats" className="px-8 py-3 rounded-xl font-semibold text-white text-lg transition-all"
                  style={{ background: 'linear-gradient(135deg, #06b6d4, #0891b2)', boxShadow: '0 4px 20px rgba(6,182,212,0.3)' }}>
              Cerca Stock B2B
            </Link>
            <Link to="/register" className="px-8 py-3 rounded-xl font-semibold text-lg transition-all"
                  style={{ background: 'rgba(255,255,255,0.1)', color: 'white', border: '1px solid rgba(255,255,255,0.2)' }}>
              Diventa Dealer
            </Link>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="py-16 px-4">
        <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { value: '€800M+', label: 'Mercato B2B Italia', icon: Euro },
            { value: '12.000', label: 'Unità/anno scambiate', icon: Package },
            { value: '72gg', label: 'Tempo medio vendita', icon: TrendingUp },
            { value: '65%', label: 'Dealer usano marketplace', icon: Users },
          ].map((stat, i) => (
            <div key={i} className="rounded-2xl p-6 text-center" 
                 style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
              <stat.icon className="mx-auto mb-3" size={28} style={{ color: '#22d3ee' }} />
              <div className="text-2xl md:text-3xl font-bold text-white mb-1">{stat.value}</div>
              <div className="text-sm" style={{ color: 'rgba(255,255,255,0.6)' }}>{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Come funziona */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Come Funziona il Mercato B2B</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {[
              { step: '1', title: 'Pubblica Stock', desc: 'Inserisci le barche con foto professionali, specifiche tecniche e prezzo B2B (15-25% sotto il retail).' },
              { step: '2', title: 'Contatti Diretti', desc: 'Dealer certificati e broker contattano direttamente. Niente intermediari, niente commissioni nascoste.' },
              { step: '3', title: 'Transazione Sicura', desc: 'Contratto tra partite IVA, fattura elettronica, documentazione completa. Pagamenti dilazionati disponibili.' },
            ].map((item, i) => (
              <div key={i} className="rounded-2xl p-6" 
                   style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <div className="w-10 h-10 rounded-full flex items-center justify-center mb-4 font-bold text-lg"
                     style={{ background: 'rgba(6,182,212,0.2)', color: '#22d3ee' }}>
                  {item.step}
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: '1.6' }}>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Volumi B2B per categoria */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-4">Volumi di Compravendita B2B</h2>
          <p className="text-center mb-8" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Dati mercato Italia 2024-2025 (fonte: UCINA, Osservatorio Nautico Nazionale)
          </p>
          <div className="rounded-2xl overflow-hidden" style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
            <table className="w-full text-left">
              <thead>
                <tr style={{ background: 'rgba(6,182,212,0.1)' }}>
                  <th className="px-6 py-4 text-sm font-semibold text-white">Categoria</th>
                  <th className="px-6 py-4 text-sm font-semibold text-white">Unità/anno</th>
                  <th className="px-6 py-4 text-sm font-semibold text-white">Valore medio</th>
                  <th className="px-6 py-4 text-sm font-semibold text-white">% mercato</th>
                </tr>
              </thead>
              <tbody>
                {[
                  { cat: 'Barche a motore 6-10m', units: '3.800', value: '€45.000', pct: '32%' },
                  { cat: 'Barche a motore 10-15m', units: '2.400', value: '€110.000', pct: '20%' },
                  { cat: 'Gommoni e RIB', units: '2.100', value: '€22.000', pct: '17%' },
                  { cat: 'Motori fuoribordo', units: '3.000', value: '€8.500', pct: '25%' },
                  { cat: 'Accessori e parti', units: '5.000+', value: '€1.200', pct: '—' },
                ].map((row, i) => (
                  <tr key={i} style={{ borderTop: '1px solid rgba(255,255,255,0.08)' }}>
                    <td className="px-6 py-3 text-sm text-white">{row.cat}</td>
                    <td className="px-6 py-3 text-sm" style={{ color: '#22d3ee' }}>{row.units}</td>
                    <td className="px-6 py-3 text-sm text-white">{row.value}</td>
                    <td className="px-6 py-3 text-sm text-white">{row.pct}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Vantaggi */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Perché il B2B Conviene</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { icon: TrendingUp, title: 'Rotazione Rapida', desc: '72 giorni contro 120 della media di mercato. Il 38% dei dealer incrementa il margine del 15-20%.' },
              { icon: Package, title: 'Stock Accessibile', desc: 'Accesso a barche altrimenti non disponibili. Diversifica l\'inventario senza immobilizzare capitale.' },
              { icon: Euro, title: 'Margine Superiore', desc: 'La negoziazione B2B esclude i costi di intermediazione retail. Pagamenti dilazionati disponibili.' },
              { icon: FileCheck, title: 'Documentazione Completa', desc: 'Perizie tecniche, storico manutenzione, certificazioni. Il 62% dei dealer preferisce stock certificato.' },
            ].map((item, i) => (
              <div key={i} className="flex gap-4 rounded-2xl p-6"
                   style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <item.icon className="shrink-0 mt-1" size={24} style={{ color: '#22d3ee' }} />
                <div>
                  <h3 className="text-lg font-semibold text-white mb-1">{item.title}</h3>
                  <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '14px', lineHeight: '1.6' }}>{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-white text-center mb-12">Domande Frequenti</h2>
          <div className="space-y-4">
            {[
              { q: 'Come acquistare barche usate come concessionario?', a: 'Registrati come dealer certificato, sfoglia lo stock B2B, filtra per marca, modello, prezzo e lunghezza. Contatta il venditore e negozia direttamente nella piattaforma.' },
              { q: 'Quali documenti servono per la compravendita B2B?', a: 'Contratto tra partite IVA, fattura elettronica, certificato di proprietà, certificato di navigabilità, visura ipotecaria. Per imbarcazioni comunitarie serve la dichiarazione IVA di regime speciale.' },
              { q: 'Quanto tempo ci vuole per vendere una barca B2B?', a: 'In media 72 giorni su piattaforme digitali specializzate, contro i 120 giorni della media di mercato. Il 38% dei dealer ha incrementato il margine del 15-20%.' },
              { q: 'Quali vantaggi fiscali ha la compravendita tra soggetti IVA?', a: 'Le cessioni tra soggetti IVA nazionali sono imponibili IVA al 22% con detrazione integrale. Per uso commerciale (navigazione alto mare) è possibile il regime di non imponibilità. Reverse charge per acquisti intracomunitari.' },
              { q: 'Quali barche si scambiano più frequentemente nel B2B?', a: 'Open e bowrider (28%), gommoni chiglia rigida (22%), flybridge 10-15m (18%), motori fuoribordo (25%). I volumi sono concentrati su imbarcazioni tra 6 e 15 metri.' },
            ].map((item, i) => (
              <details key={i} className="rounded-2xl overflow-hidden" 
                       style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)' }}>
                <summary className="px-6 py-4 cursor-pointer font-semibold text-white list-none flex items-center justify-between">
                  {item.q}
                  <span style={{ color: '#22d3ee', fontSize: '20px' }}>+</span>
                </summary>
                <div className="px-6 pb-4" style={{ color: 'rgba(255,255,255,0.7)', fontSize: '14px', lineHeight: '1.7' }}>
                  {item.a}
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* CTA finale */}
      <section className="py-20 px-4 text-center">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl font-bold text-white mb-4">Inizia a Compravendere B2B Oggi</h2>
          <p className="text-lg mb-8" style={{ color: 'rgba(255,255,255,0.6)' }}>
            Unisciti alla rete di dealer certificati in Italia e Mediterraneo
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/register" className="px-8 py-4 rounded-xl font-bold text-lg text-white transition-all"
                  style={{ background: 'linear-gradient(135deg, #06b6d4, #0891b2)', boxShadow: '0 4px 20px rgba(6,182,212,0.3)' }}>
              Registrati come Dealer
            </Link>
            <Link to="/boats" className="px-8 py-4 rounded-xl font-bold text-lg transition-all"
                  style={{ background: 'rgba(255,255,255,0.1)', color: 'white', border: '1px solid rgba(255,255,255,0.2)' }}>
              Esplora Stock B2B
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
